import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import router from './router'
// import JsonExcel from 'vue-json-excel'

const app = createApp(App)

app
  .use(ElementPlus, {
    locale: zhCn
  })
  // .use(JsonExcel)
  .use(router)
  .mount('#app')
